import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import MostActiveIndexOptionsFull from './most-active-index-options-full';

const MostActiveIndexOptionsFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <MostActiveIndexOptionsFull {...props} />
    </QueryClientProvider>
  );
};

export { MostActiveIndexOptionsFullWidget }
